import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        grid: {
            columns: 4,
            spacing: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
            gap: remCalc(24),
        },
        gridItem: {
            display: 'flex',
            flexDir: 'column',
            alignItems: 'center',
            width: remCalc(72),
            height: remCalc(72),
            p: remCalc(1),
        },
        colorCircleContainer: {
            borderStyle: 'solid',
            borderColor: 'black',
            borderRadius: 'full',
            padding: remCalc(2),
        },
        colorCircle: {
            m: 0,
            height: '100%',
            width: '100%',
            minWidth: remCalc(32),
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            borderRadius: 'full',
        },
        textContainer: {
            display: 'flex',
            flexDir: 'row',
            gap: 2,
            color: 'text.default',
            textAlign: 'center',
            textStyle: 'body-small',
            fontWeight: 'normal',
        },
        hitCount: {
            color: 'text.secondary',
        },
    },
}
